import { trySaveToLocalStorage } from '@omnea-app/fe-browser-utils/trySaveToLocalStorage'

export class CourierLocalStorage {
  get length(): number {
    return localStorage.length
  }

  clear(): void {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Unable to clear local storage', error)
    }
  }

  key(index: number): string | null {
    try {
      return localStorage.key(index)
    } catch (error) {
      console.error('Unable to find the item at the given index in local storage', error)
      return null
    }
  }

  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      console.error('Unable to get item from local storage', error)
      return null
    }
  }

  setItem(key: string, value: string): void {
    trySaveToLocalStorage({ key, value })
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Unable to remove item from local storage', error)
    }
  }
}
